
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shoes/simulation",
      function () {
        return require("private-next-pages/shoes/simulation.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shoes/simulation"])
      });
    }
  